// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".m-label[data-v-07389d03] {\n  padding-bottom: 0.694vw;\n}\n", "",{"version":3,"sources":["/Users/mht/Desktop/Work/GE/SPO-V-FE/src/components/edit-andon.vue"],"names":[],"mappings":"AACE;EACE,uBAAA;AAAJ","file":"edit-andon.vue","sourcesContent":["\n  .m-label {\n    padding-bottom: 10px;\n  }\n\n@spo-color-blue: #46649f;@spo-margin: 20px;@spo-padding: 20px;@spo-header-height: 65px;@primary-color: #46649f;@link-color: #46649f;"]}]);
// Exports
module.exports = exports;
